import type { RouteRecordRaw } from 'vue-router';
import NavigationRailView from '@/services/router/views/NavigationRailView.vue';
import ContactDetailView from '@/lead/contact/views/ContactDetailView.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/contacten/:contactId',
        name: 'contact-detail',
        components: {
            default: ContactDetailView,
            rail: NavigationRailView,
        },
    },
];

export default routes;
